// ============================================
// Stores Index
// ============================================

export * from './auth';
export * from './search';
export * from './tenant';

// ============================================
// Command Search UI Store
// ============================================
import { create } from 'zustand';

interface CommandSearchState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useCommandSearchStore = create<CommandSearchState>()(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set(state => ({ isOpen: !state.isOpen })),
}));
